/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

interface IArgs {
  isChecked: boolean;
  onClick: () => void;
  isDisabled?: boolean;
  showState?: boolean;
  tooltip?: string;
}

interface ToggleSignature {
  Element: HTMLSpanElement;

  Args: IArgs;
}

const UiProtectionSettingsToggleComponent = templateOnly<ToggleSignature>();

export default UiProtectionSettingsToggleComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Protection::Settings::Toggle': typeof UiProtectionSettingsToggleComponent;
  }
}
